export enum EInputsIds {
  Email = 'email',
  Lastname = 'lastName',
  Name = 'name',
  Password = 'password',
  Role = 'role',
  Search = 'input-search',
  Username = 'username',
}
